import * as cc from 'cc';
import { TweenEasing } from 'cc';

export enum EasingType {
    linear,
    smooth,
    fade,
    constant,
    quadIn,
    quadOut,
    quadInOut,
    quadOutIn,
    cubicIn,
    cubicOut,
    cubicInOut,
    cubicOutIn,
    quartIn,
    quartOut,
    quartInOut,
    quartOutIn,
    quintIn,
    quintOut,
    quintInOut,
    quintOutIn,
    sineIn,
    sineOut,
    sineInOut,
    sineOutIn,
    expoIn,
    expoOut,
    expoInOut,
    expoOutIn,
    circIn,
    circOut,
    circInOut,
    circOutIn,
    elasticIn,
    elasticOut,
    elasticInOut,
    elasticOutIn,
    backIn,
    backOut,
    backInOut,
    backOutIn,
    bounceIn,
    bounceOut,
    bounceInOut,
    bounceOutIn,
}

export function getEasingProgress(type: EasingType, percent: number): number {
    switch (type) {
        case EasingType.quadOut:
            return 1 - (1 - percent) * (1 - percent);
        default:
            return percent;
    }
}

export function easingEnumToFunction(fromEnum: EasingType): (x: number) => number {
    switch (fromEnum) {
        case EasingType.linear:
            return cc.easing.linear;
        case EasingType.smooth:
            return cc.easing.smooth;
        case EasingType.fade:
            return cc.easing.fade;
        case EasingType.constant:
            return cc.easing.constant;
        case EasingType.quadIn:
            return cc.easing.quadIn;
        case EasingType.quadOut:
            return cc.easing.quadOut;
        case EasingType.quadInOut:
            return cc.easing.quadInOut;
        case EasingType.quadOutIn:
            return cc.easing.quadOutIn;
        case EasingType.cubicIn:
            return cc.easing.cubicIn;
        case EasingType.cubicOut:
            return cc.easing.cubicOut;
        case EasingType.cubicInOut:
            return cc.easing.cubicInOut;
        case EasingType.cubicOutIn:
            return cc.easing.cubicOutIn;
        case EasingType.quartIn:
            return cc.easing.quartIn;
        case EasingType.quartOut:
            return cc.easing.quartOut;
        case EasingType.quartInOut:
            return cc.easing.quartInOut;
        case EasingType.quartOutIn:
            return cc.easing.quartOutIn;
        case EasingType.quintIn:
            return cc.easing.quintIn;
        case EasingType.quintOut:
            return cc.easing.quintOut;
        case EasingType.quintInOut:
            return cc.easing.quintInOut;
        case EasingType.quintOutIn:
            return cc.easing.quintOutIn;
        case EasingType.sineIn:
            return cc.easing.sineIn;
        case EasingType.sineOut:
            return cc.easing.sineOut;
        case EasingType.sineInOut:
            return cc.easing.sineInOut;
        case EasingType.sineOutIn:
            return cc.easing.sineOutIn;
        case EasingType.expoIn:
            return cc.easing.expoIn;
        case EasingType.expoOut:
            return cc.easing.expoOut;
        case EasingType.expoInOut:
            return cc.easing.expoInOut;
        case EasingType.expoOutIn:
            return cc.easing.expoOutIn;
        case EasingType.circIn:
            return cc.easing.circIn;
        case EasingType.circOut:
            return cc.easing.circOut;
        case EasingType.circInOut:
            return cc.easing.circInOut;
        case EasingType.circOutIn:
            return cc.easing.circOutIn;
        case EasingType.elasticIn:
            return cc.easing.elasticIn;
        case EasingType.elasticOut:
            return cc.easing.elasticOut;
        case EasingType.elasticInOut:
            return cc.easing.elasticInOut;
        case EasingType.elasticOutIn:
            return cc.easing.elasticOutIn;
        case EasingType.backIn:
            return cc.easing.backIn;
        case EasingType.backOut:
            return cc.easing.backOut;
        case EasingType.backInOut:
            return cc.easing.backInOut;
        case EasingType.backOutIn:
            return cc.easing.backOutIn;
        case EasingType.bounceIn:
            return cc.easing.bounceIn;
        case EasingType.bounceOut:
            return cc.easing.bounceOut;
        case EasingType.bounceInOut:
            return cc.easing.bounceInOut;
        case EasingType.bounceOutIn:
            return cc.easing.bounceOutIn;
        default:
            break;
    }
    return cc.easing.linear;
}

export function easeOutBounce(x: number): number {
    const n1 = 7.5625;
    const d1 = 2.75;

    if (x < 1 / d1) {
        return n1 * x * x;
    }
    if (x < 2 / d1) {
        x -= 1.5;
        return n1 * (x / d1) * x + 0.75;
    }
    if (x < 2.5 / d1) {
        x -= 2.25;
        return n1 * (x / d1) * x + 0.9375;
    }
    x -= 2.625;
    return n1 * (x / d1) * x + 0.984375;
}

export function toTweenEasing(easingType: EasingType): TweenEasing {
    return EasingType[easingType] as TweenEasing;
}

export const enumTypesName: string[] = Object.keys(EasingType)
    .map((key) => EasingType[key])
    .filter((value) => Number.isNaN(+value));
